/* @flow */

import $ from 'jquery';
import React, { Component } from 'react';
import fetch, { handleFetchError } from 'utils/fetch';
import { displayJsonError } from 'utils/errors';
import { mountComponent, unmountCurrentComponent } from 'utils/modals';
import { storeSuccess } from './toastr';
import DeleteModal from 'shared/components/DeleteModal';

export default () => {
  $('.button.delete').on('click', confirmDelete);
};

function confirmDelete(event) {
  const $button = $(event.currentTarget);

  const url = $button.attr('data-url');
  const content = $button.attr('data-content');
  const method = $button.attr('data-method') || 'DELETE';

  if (url && content) {
    showModal(url, method, content);
  } else {
    console.warn(
      'Trying to confirm deletion without required data attributes (url, content)'
    );
  }
}

function deleteConfirmed() {
  unmountCurrentComponent();

  // Storing success notification
  storeSuccess('Suppression effectuée avec succès');

  // Reloading page
  window.location.reload(true);
}

type Props = {
  url: string,
  method: string,
  content: string,
};

type State = {
  error?: string,
  isDeleting: boolean,
};

class ModalWrapper extends Component {
  props: Props;
  state: State;

  constructor(props) {
    super(props);

    this.state = {
      isDeleting: false,
    };
  }

  onDelete = () => {
    const { url, method } = this.props;

    this.setState({
      isDeleting: true,
    });

    fetch(url, { method })
      .then(deleteConfirmed, handleFetchError)
      .catch(error => {
        this.setState({
          isDeleting: false,
          error: displayJsonError(error),
        });
      });
  };

  render() {
    const { content } = this.props;
    const { isDeleting, error } = this.state;

    return (
      <DeleteModal
        open={true}
        loading={isDeleting}
        error={error}
        content={content}
        onConfirm={this.onDelete}
        onClose={unmountCurrentComponent}
      />
    );
  }
}

function showModal(url, method, content) {
  mountComponent(<ModalWrapper url={url} method={method} content={content} />);
}



// WEBPACK FOOTER //
// ./src/plugins/confirm-delete.js